import type {EmptyPayload} from 'constants/events/EventPayloadUtils';
import type {TagSchema} from 'constants/RegistryConstants';
import type {RequestSchema} from 'requests/RequestConstants';
import type {AssaySchema} from 'results/assay-schemas/AssaySchemaConstants';
import type {
  SchemaFieldSelector,
  SchemaFieldSelectorOptionToUpdate,
} from 'schemas/SchemaFieldSelectorConstants';

export const SCHEMA_EVENT_PAYLOADS = {
  TAG_SCHEMA_UPDATED: {} as {
    tagSchema: TagSchema;
  },

  BATCH_SCHEMA_SAVING_COMPLETED: {} as EmptyPayload,

  SCHEMA_FIELD_SELECTOR_CREATE_COMPLETED: {} as {
    registryId: string;
    selector: SchemaFieldSelector;
  },
  SCHEMA_FIELD_SELECTOR_DELETE_COMPLETED: {} as {
    selectorId: string;
  },
  SCHEMA_FIELD_SELECTOR_UPDATE_CANCELED: {} as EmptyPayload,
  SCHEMA_FIELD_SELECTOR_UPDATE_COMPLETED: {} as {
    registryId: string;
    selector: SchemaFieldSelector;
  },
  SCHEMA_FIELD_SELECTOR_UPDATE_FAILED: {} as {
    selectorOptionToUpdate: SchemaFieldSelectorOptionToUpdate;
  },
  SCHEMA_FIELD_SELECTORS_FETCH_COMPLETED: {} as {
    selectorsByRegistryId: {[registryId: string]: Array<SchemaFieldSelector>};
  },
  SCHEMA_FIELD_SELECTORS_FETCH_FAILED: {} as EmptyPayload,
  SCHEMA_FIELD_SELECTORS_FETCH_STARTED: {} as EmptyPayload,

  ASSAY_SCHEMAS_LISTED: {} as {
    assaySchemas: Array<AssaySchema | RequestSchema>;
  },
  ASSAY_SCHEMA_FETCHED: {} as {
    assaySchema: AssaySchema;
  },
  ASSAY_SCHEMAS_UPDATED_FROM_GQL: {} as {
    assaySchemas: Array<AssaySchema>;
  },
} as const;

export type SchemaEventPayload = typeof SCHEMA_EVENT_PAYLOADS;
